import { render, staticRenderFns } from "./MStoreNarrativeTab.vue?vue&type=template&id=3c13d525&"
import script from "./MStoreNarrativeTab.vue?vue&type=script&lang=ts&"
export * from "./MStoreNarrativeTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports